import dayjs from 'dayjs';
// Place holder to share helper methods (like loading of dates/month/year for birthdate, start date,loading country names etc.)
// can also store shared custom validations across pages(say if email is validated in differnt pages).

const _monthsShort = [
  "Jan", "Feb", "Mar", "Apr", "May", "Jun",
  "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
];

export class DateValuesGenerator {    
  constructor() { 
    dayjs.locale('en') // use english locale globally
  }
  // for ex: 1 to 31
  static returnDays(monthYear: string): number[] {    
    const numberOfDays = dayjs(monthYear, 'YYYY-MM').daysInMonth();
    const days = [];
    for (let i = 1; i <= numberOfDays; i += 1) {
      days.push(i);
    }
    return days;
  }
  static returnPrevDays(monthYear: string, currentDate: number): number[] {
    const numberOfDays = dayjs(monthYear, 'YYYY-MM').daysInMonth();
    const days = [];
    for (let i = 1; i <= numberOfDays; i += 1) {
      if (i <= currentDate) {
        days.push(i);
      }
    }
    return days;
  }
  // howmanyYears -the value.For ex. do you want to return past 50 years/100 years..
  static returnYears(pastYears: number, futureYears: number = 0): any {
    const years = [];
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const futureYear = currentYear + futureYears;
    const lastPreviousYearsFromToday = currentYear - pastYears + 1; // returns past 100 from today, if howmanyYears=100.
    for (let i = lastPreviousYearsFromToday; i <= futureYear; i += 1) {
      years.push(i);
    }
    return years;
  }
  static returnMonths(): any {
    const months = [];
    const monthstrings =  _monthsShort; // moment.monthsShort()
    for (let i = 0; i < monthstrings.length; i += 1) {
      months.push({id: i + 1, name : monthstrings[i]});
    }
    return months;
  }
  static returnPrevMonths(currentMonth: number): any {
    const months = [];
    const monthstrings = _monthsShort;// moment.monthsShort()
    for (let i = 0; i < monthstrings.length; i += 1) {
      if (i <= currentMonth) {
        months.push({id: i + 1, name: monthstrings[i]});
      }
    }
    return months;
  }
}
